var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loginLayout(_vm.$route))?_c('LoginLayout'):(_vm.mainLayout(_vm.$route))?_c('MainLayout'):_c('NotFoundLayout')],1)}
var staticRenderFns = []

export { render, staticRenderFns }